import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import { Button, PageHeader } from "antd";
import { searchPayments } from "../../redux/actions";
import PaymentTable from "./PaymentTable";

export default ({ hideHeader, presetFilters }) => {
  const intl = useIntl();
  const history = useHistory();
  const dispatch = useDispatch();

  const [data, setData] = useState({ data: [], total: 0 });

  const fetchData = (page, size, filters = {}, sort = {}) => {
    return dispatch(searchPayments(page, size, filters, sort))
      .then(({ payload }) => setData(payload));
  };

  return (
    <div className="page-wrapper">
      <PageHeader
        className="site-page-header-ghost-wrapper"
        ghost={false}
        title={intl.formatMessage({ id: "payments" })}
        extra={[
          <Button
            key="create"
            type="primary"
            onClick={() => history.push("/payments/create")}
          >
            {intl.formatMessage({ id: "create" })}
          </Button>,
        ]}
      />
      <PaymentTable fetchData={fetchData} data={data} />
    </div>
  );
};
